import React from 'react';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { HOW_IT_WORKS_STEPS } from '../../../utils/homeData';
import { useInView } from '../../../hooks/useInView';
import './HowItWorksSection.scss';

interface Props {
  onScrollToPlans: () => void;
}

export function HowItWorksSection({ onScrollToPlans }: Props) {
  const { ref, inView } = useInView<HTMLDivElement>({ threshold: 0.1 });

  return (
    <section className="how-it-works-section">
      <div className="how-it-works-section__header">
        <div className="section-eyebrow section-eyebrow--blue">COMO FUNCIONA</div>
        <h2 className="section-title">Do site ao carro limpo em 4 passos</h2>
      </div>

      <div className="how-it-works-section__grid" ref={ref}>
        {HOW_IT_WORKS_STEPS.map((step, index) => {
          const isNarrow = step.n === 3 || step.n === 4;
          return (
            <div
              key={step.n}
              className={`how-it-works-section__card animate-on-scroll${inView ? ' is-visible' : ''}`}
              style={{ transitionDelay: `${index * 0.14}s` }}
            >
              <div className="how-it-works-section__card-text">
                <div className="how-it-works-section__card-title">{step.title}</div>
                <div className="how-it-works-section__card-desc">{step.desc}</div>
              </div>
              <div className="how-it-works-section__card-image-wrap">
                <img
                  src={step.img}
                  alt={step.title}
                  className={`how-it-works-section__card-image how-it-works-section__card-image--${isNarrow ? 'narrow' : 'wide'}`}
                />
              </div>
            </div>
          );
        })}
      </div>

      <p className="how-it-works-section__footer-note">
        Assine → Baixe o app → Lavagens ilimitadas
      </p>
      <div className="how-it-works-section__cta">
        <button className="btn-cta-green" onClick={onScrollToPlans}>
          <DirectionsCarIcon sx={{ fontSize: 20 }} />
          Assine já
        </button>
      </div>
    </section>
  );
}
